/* unplugin-vue-components disabled */import script from "./sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=0733d6d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0733d6d0"]])

export default __exports__